export default "__VITE_ASSET__687af1ca__"